import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';

import { UserContext } from '~/components/providers/UserProvider';
import { getLeagues, LEAGUES_CACHE_TIME } from '~/services/games-service/games-service.service.api';

export const LeagueQueryKeys = {
  LEAGUES: (userId?: string | null) => ['leagues', userId ?? 'guest'] as const,
};

type UseLeaguesOptions = { enabled?: boolean };

export const useLeagues = ({ enabled = true }: UseLeaguesOptions = {}) => {
  const { userId } = useContext(UserContext);

  return useQuery({
    queryKey: LeagueQueryKeys.LEAGUES(userId),
    queryFn: () => getLeagues(),
    staleTime: LEAGUES_CACHE_TIME,
    cacheTime: LEAGUES_CACHE_TIME,
    enabled,
  });
};
